// extracted by mini-css-extract-plugin
export default {"tableContainer":"PungoTable_tableContainer__vjgZ7","energySources":"PungoTable_energySources__McOnt","cell":"PungoTable_cell__Y5V2c"};